import { useState, createContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
export const dataContext = createContext();

const DataProvider = (props) => {
  const [data, setData] = useState({});
  const location = useLocation();

  useEffect(() => {
    setData({});
  }, [location.pathname]);
  return (
    <dataContext.Provider value={[data, setData]}>
      {props.children}
    </dataContext.Provider>
  );
};

export default DataProvider;
